import { render, staticRenderFns } from "./ImagesUploader.vue?vue&type=template&id=4ce634f2&"
import script from "./ImagesUploader.vue?vue&type=script&lang=js&"
export * from "./ImagesUploader.vue?vue&type=script&lang=js&"
import style0 from "./ImagesUploader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports